import PropTypes from "prop-types";
import clsx from "clsx";
import { createTestId } from "../../../utils/createTestId";

export function Switch({
  checked,
  className,
  defaultChecked,
  disabled,
  id,
  inputClassName,
  inputProps,
  label,
  labelClassName,
  labelProps,
  // labelTextClassName,
  name,
  offLabelText = "Off",
  onChange,
  onLabelText = "On",
  required,
  // showRequiredAsterisk = false,
  slideClassName,
  testId = "input",
  toggleClassName,
  value,
  ...other
}) {
  return (
    <div
      className={clsx("FormComponent", "Switch", className)}
      {...other}
      style={{ outline: "none" }}
    >
      <input
        className={clsx("Switch__input", inputClassName)}
        type="checkbox"
        name={name}
        value={value}
        id={id}
        required={required}
        disabled={disabled}
        defaultChecked={defaultChecked}
        checked={checked}
        onChange={onChange}
        data-test-id={createTestId(testId)}
        {...inputProps}
      />
      <label className={clsx("Switch__label", labelClassName)} htmlFor={id} {...labelProps}>
        <span
          className={clsx(
            "Switch__label__slide",
            slideClassName,
            value === true && "Switch__label__slide--enabled",
          )}
          data-on={onLabelText}
          data-off={offLabelText}
        />
        <span className={clsx("Switch__label__toggle", toggleClassName)} />
        {/* {label && (
          <span className={clsx("Switch__label__text", labelTextClassName)}>
            {label} {required && showRequiredAsterisk && "*"}
          </span>
        )} */}
        <p className="Switch__label__text">{value === true ? onLabelText : offLabelText}</p>
      </label>
    </div>
  );
}

Switch.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  inputClassName: PropTypes.string,
  inputProps: PropTypes.object,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelClassName: PropTypes.string,
  labelProps: PropTypes.object,
  labelTextClassName: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  showRequiredAsterisk: PropTypes.bool,
  slideClassName: PropTypes.string,
  testId: PropTypes.string,
  toggleClassName: PropTypes.string,
  value: PropTypes.bool,
};
